<template>
  <div>
    <div>
      <Tracker
        v-if="selectedTrackedBill && selectedTrackedBill.ID > 0"
        :trackedBill="selectedTrackedBill"
        @refreshTrackedBills="refreshSelectedTrackedBill"
        :isExtended="true"
      ></Tracker>
      <v-skeleton-loader
        v-else
        v-bind="{}"
        type="article,article,actions"
      ></v-skeleton-loader>
      <v-row class="pa-3">
        <v-col sm="12" md="4">
          <Comments
            :comments="selectedTrackedBillComments"
            :loading="commentsLoading"
            @refresh="loadSelectedTrackedBillComments"
          ></Comments>
        </v-col>
        <v-col sm="12" md="4">
          <Links
            :links="selectedTrackedBillLinks"
            :loading="linksLoading"
            @refresh="loadSelectedTrackedBillLinks"
          ></Links>
        </v-col>
        <v-col sm="12" md="4">
          <Documents
            :documents="selectedTrackedBillDocuments"
            :loading="documentsLoading"
            @refresh="loadSelectedTrackedBillDocuments"
          ></Documents>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <BasePanelWithHeader
            class="ma-1"
            headerText="Other Trackers for this Bill"
            collapsable
            v-if="
              selectedTrackedBillMatchingShared &&
              selectedTrackedBillMatchingShared.length > 0
            "
          >
            <v-progress-linear
              :indeterminate="matchingSharedLoading"
            ></v-progress-linear>
            <v-expansion-panels accordion multiple>
              <v-expansion-panel
                v-for="trackedBill in selectedTrackedBillMatchingShared"
                :key="trackedBill.ID"
              >
                <v-expansion-panel-header>
                  <div>
                    <a
                      @click.stop="selectBill(trackedBill)"
                      v-if="
                        trackedBill && trackedBill.ID && !trackedBill.IsSummary
                      "
                      :href="`#/bill/${trackedBill.ID}`"
                      >{{ trackedBill.BillNumber }} -
                      {{ trackedBill.ShortTitle }}</a
                    >
                    <span v-else
                      >{{ trackedBill.BillNumber }} -
                      {{ trackedBill.ShortTitle }}
                    </span>
                    <span
                      class="pl-5"
                      v-if="trackedBill && trackedBill.ID"
                      v-for="a in trackedBill.owningAgencies"
                    >
                      <v-chip small label color="primary">{{ a.Abr }}</v-chip>
                    </span>
                    <span
                      class="pl-2"
                      v-if="trackedBill && trackedBill.ID"
                      v-for="d in trackedBill.TrackedBillDivisions.filter(
                        (v, i, list) => {
                          return (
                            list.findIndex(
                              (l) => l.DivisionId == v.DivisionId
                            ) === i
                          )
                        }
                      )"
                    >
                      <v-chip small outlined color="primary"
                        ><span>
                          <span v-if="trackedBill.owningAgencies.length > 1">
                            {{ d.Division.Agency.Abr }}:
                          </span>
                          {{ d.Division.Description }}
                        </span>
                      </v-chip>
                    </span>
                    <span class="ml-1">
                      <BaseTooltipChip
                        v-if="trackedBill.IsSummary"
                        label
                        color="secondary"
                        small
                        position="right"
                        icon="mdi-eye-off"
                        >Summary Only</BaseTooltipChip
                      >
                    </span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <SharedTracker
                    :trackedBill="trackedBill"
                    @refreshTrackedBills="loadSelectedTrackedBill"
                  ></SharedTracker>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </BasePanelWithHeader>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import TrackedBill from '@classes/TrackedBill'
import Tracker from '@components/lso/Tracker'
import SharedTracker from '@components/lso/SharedTracker'
import Comments from '@components/grid/CommentGrid'
import Documents from '@components/grid/DocumentGrid'
import Links from '@components/grid/LinkGrid'
export default {
  page() {
    return {
      title: this.selectedTrackedBill
        ? this.selectedTrackedBill.BillNumber
        : 'Bill Details',
    }
  },
  //model: {
  //	prop: ''
  //},
  props: {},
  components: {
    Tracker,
    SharedTracker,
    Comments,
    Documents,
    Links,
  },
  filters: {},
  data() {
    return {
      basePdfLink: 'https://www.wyoleg.gov/',
      baseBillLink: 'https://www.wyoleg.gov/Legislation/',
    }
  },
  created() {
    if (this.$route.params.id) {
      this.loadSelectedTrackedBill(this.$route.params.id)
      this.loadSelectedTrackedBillComments()
      this.loadSelectedTrackedBillLinks()
      this.loadSelectedTrackedBillDocuments()
      this.loadSelectedTrackedBillMatchingShared()
    }
  },
  computed: {
    ...get('bills', ['selectedBill', 'itemLoading']),
    ...get('trackedBill', [
      'loading',
      'saving',
      'selectedTrackedBillComments',
      'commentsLoading',
      'selectedTrackedBillDocuments',
      'documentsLoading',
      'selectedTrackedBillLinks',
      'linksLoading',
      'selectedTrackedBillMatchingShared',
      'matchingSharedLoading',
      'selectedTrackedBill',
    ]),
  },
  methods: {
    ...call('bills', ['loadSelectedBill']),
    ...call('trackedBill', [
      'loadSelectedTrackedBill',
      'setSelectedTrackedBill',
      'refreshSelectedTrackedBill',
      'loadSelectedTrackedBillMatchingShared',
      'loadSelectedTrackedBillComments',
      'loadSelectedTrackedBillDocuments',
      'loadSelectedTrackedBillLinks',
    ]),
    selectBill(bill) {
      this.setSelectedTrackedBill(bill)
      this.$router.push({
        name: 'bill',
        params: { id: bill.ID },
      })
    },
  },
  watch: {},
}
</script>
<style>
.viewer {
  border-radius: 5px;
  /* margin: 5px; */
  max-height: 600px;
  min-height: 550px;
  height: auto;
  background-color: #f7f7f7;
  -webkit-box-shadow: inset 0 0 10px #e2e2e2;
  box-shadow: inset 0 0 10px #e2e2e2;
  overflow-y: scroll;
  padding: 5px 0px 10px 0px;
}
.user-data {
  margin: 5px;
  color: var(--v-accent-base);
  font-size: 12px;
}
</style>
